import {Text} from '#component/base';
import {
  HeaderSubscriptionProps,
  SubscriptionManagerState,
} from '#component/page/Profile/components/ManagePlanTab/SubscriptionManager/SubscriptionManager.types';
import {useSubscriptionManager} from '#component/page/Profile/components/ManagePlanTab/SubscriptionManager/SubscriptionManagerContext';

import * as css from './HeaderSubscription.css';

export const HeaderSubscription = ({
  title,
  textColor,
  isDiscounted,
  state,
  totalValue,
  totalValueWithDiscount,
  startingAtValue,
}: HeaderSubscriptionProps) => {
  const {selectedSupplementsCount} = useSubscriptionManager();

  return (
    <div>
      <Text variant="heading2" color="deepBurgundy" className={css.Title}>
        {title}
      </Text>
      <div>
        <Text
          color={textColor}
          className={`${
            isDiscounted && state !== SubscriptionManagerState.DESELECTED ? css.LineThrough : ''
          } ${css.TextTotalStyles}`}>
          {state === SubscriptionManagerState.DESELECTED || selectedSupplementsCount === 0
            ? `Starting at $${startingAtValue}`
            : `$${totalValue}`}
        </Text>
        {isDiscounted && state !== SubscriptionManagerState.DESELECTED ? (
          <Text className={css.TextTotalStyles} color="eggplant">
            {' '}
            ${totalValueWithDiscount}/mo
          </Text>
        ) : (
          <Text className={css.TextTotalStyles} color={textColor}>
            /mo
          </Text>
        )}
      </div>
    </div>
  );
};
